/** Run `callback` against `obj` and recursively through children.
 * If callback returns false, will stop going deeper */
function RgTraverse(obj, callback) {
    if (callback(obj) === false)
        return;
    for (const c of obj.children) {
        RgTraverse(c, callback);
    }
}

export { RgTraverse };
//# sourceMappingURL=rg-traverse.js.map
